module.exports = __webpack_public_path__ + "img/88.cb766d90.jpg";